// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"6c1e1973","531":"6c1e1973"}[chunkId] + ".chunk.css";
};